export default __webpack_public_path__ + "static/media/logo-001-01.9299fd37.png";